import { createVanIconComponent } from "./van"

const NewArrivalOutlined = createVanIconComponent("new-arrival-o")
export default NewArrivalOutlined
